/**
 * PATH: packages/email-hub/src/_internal/lib/emailSurfaceBackground.ts
 * FILE_ID: EMAILHUB-SURFACE-BG-COERCE-001
 * PURPOSE: Pure coerce/type for Email workspace background prefs.
 * WHY:     Kept free of @quotech/ui/kanban so uiStore (and its tests)
 *          never pull the heavy kanban barrel / quote-builder graph.
 */
export type EmailSurfaceBackground = {
  theme_preset?: string
  bg_color?: string
  bg_image_id?: string
  bg_image_url?: string
}

const EMPTY: EmailSurfaceBackground = {}

/** Coerce untrusted layout_json.background into a safe blob. */
export function coerceEmailBackground(raw: unknown): EmailSurfaceBackground {
  if (!raw || typeof raw !== 'object') return { ...EMPTY }
  const o = raw as Record<string, unknown>
  const out: EmailSurfaceBackground = {}
  if (typeof o.theme_preset === 'string' && o.theme_preset.trim()) {
    out.theme_preset = o.theme_preset.trim()
  }
  if (typeof o.bg_color === 'string' && o.bg_color.trim()) {
    out.bg_color = o.bg_color.trim()
  }
  if (typeof o.bg_image_id === 'string') {
    out.bg_image_id = o.bg_image_id
  }
  if (typeof o.bg_image_url === 'string' && o.bg_image_url.trim()) {
    out.bg_image_url = o.bg_image_url.trim()
  }
  return out
}

export function hasEmailBackground(bg: EmailSurfaceBackground | null | undefined): boolean {
  if (!bg) return false
  return Boolean(bg.theme_preset || bg.bg_color || bg.bg_image_id || bg.bg_image_url)
}
